/** The SynAnalytics terms of service, in plain language. */

import type { ReactNode } from 'react';

export const TERMS_UPDATED = '23 October 2026';
const CONTACT = 'synteralabs.sa@gmail.com';

export function TermsOfService(): ReactNode {
  return (
    <>
      <p>
        These terms are an agreement between you (and the organisation you sign up for) and Syntera
        Labs, South Africa, for the use of SynAnalytics. By creating an account or using the service
        you accept them.
      </p>

      <h2>The service</h2>
      <p>
        SynAnalytics lets agencies connect their clients’ marketing and business accounts, and build
        dashboards and reports from them. We keep improving it, so features may change; we will not
        remove something you rely on without telling you first.
      </p>

      <h2>Your account</h2>
      <ul>
        <li>Keep your sign-in details and two-step verification to yourself.</li>
        <li>
          You are responsible for the people you invite to your organisation and what they do in it.
        </li>
        <li>Tell us straight away if you think someone else has used your account.</li>
      </ul>

      <h2>Connecting other accounts</h2>
      <p>
        Only connect accounts you are allowed to use, such as your own or a client’s that has given
        you access. Access is read-only: SynAnalytics reads numbers and does not change anything in
        the accounts you connect. You can disconnect at any time. Each connected service’s own terms
        still apply to your use of it.
      </p>

      <h2>Acceptable use</h2>
      <p>Do not use SynAnalytics to:</p>
      <ul>
        <li>break the law or anyone’s rights, including privacy rights;</li>
        <li>get into accounts or data you are not allowed to see;</li>
        <li>overload, attack, copy or take apart the service;</li>
        <li>share reports with people who should not receive them.</li>
      </ul>

      <h2>Your data</h2>
      <p>
        What you put into SynAnalytics, and the data from accounts you connect, stays yours. You let
        us store and process it only to run the service for you, as our{' '}
        <a href="/privacy">Privacy Policy</a> describes.
      </p>

      <h2>Trial, plans and payment</h2>
      <p>
        New organisations start with a free trial. Paid plans, their prices and what they include
        are shown before you subscribe; fees are charged in advance and are not refundable for a
        period already started, except where the law says otherwise.
      </p>

      <h2>Availability and liability</h2>
      <p>
        We work to keep SynAnalytics available and accurate, but it is provided “as is”: connected
        services can be slow, change or be unavailable, and numbers shown are only as accurate as
        their source. As far as the law allows, we are not liable for indirect or consequential
        loss, and our total liability is limited to the fees you paid us in the twelve months before
        the claim.
      </p>

      <h2>Ending the agreement</h2>
      <p>
        You may stop using SynAnalytics at any time. We may suspend or close an account that breaks
        these terms, after telling you why where we can.
      </p>

      <h2>Changes and law</h2>
      <p>
        If we change these terms we will update the date above and tell account owners before a
        change that matters takes effect. South African law applies.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these terms: <a href={`mailto:${CONTACT}`}>{CONTACT}</a>.
      </p>
    </>
  );
}
